import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerScrabbleTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  ScrabbleDefinition,
  ScrabblePresence,
  ScrabbleProgress,
  ScrabbleSolution,
  ScrabbleSubmission,
} from "./types";

registerScrabbleTranslations(i18n);

export const scrabbleModule: PuzzleTypeModule<
  ScrabbleDefinition,
  ScrabbleSubmission,
  ScrabbleProgress,
  ScrabbleSolution,
  ScrabblePresence
> = {
  key: "scrabble",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  // Legality and points from the public board alone; the dictionary stays on the server.
  localFeedback,
};
